/**
 * PDFSnippetOverlay - Overlay to show saved snippet area
 *
 * Extracted from PDFViewerModal.tsx
 */

import React from 'react';
import type { Theme } from '../../../themes/theme';
import type { PDFCoords } from '../types/pdf-viewer.types';

export interface PDFSnippetOverlayProps {
  theme: Theme;
  snippetOverlayRect: PDFCoords | null;
}

export function PDFSnippetOverlay({ theme, snippetOverlayRect }: PDFSnippetOverlayProps) {
  if (!snippetOverlayRect) return null;

  return (
    <div
      className="absolute border-2 border-nb-focus z-10 pointer-events-none"
      style={{
        left: `${snippetOverlayRect.x}px`,
        top: `${snippetOverlayRect.y}px`,
        width: `${snippetOverlayRect.width}px`,
        height: `${snippetOverlayRect.height}px`,
        backgroundColor: `rgb(var(--nb-success-rgb) / 0.15)`,
        boxShadow: `0 0 0 2px rgb(var(--nb-success-rgb) / 0.3)`,
      }}
    >
      <div
        className={`absolute -top-6 left-0 ${theme.colors.bg.tertiary} ${theme.colors.text.inverse} px-2 py-1 rounded text-xs font-medium shadow-lg`}
      >
        📌 Fragmento Guardado
      </div>
    </div>
  );
}
